const sleep = (ms) =>
  /* eslint-disable-next-line */
  new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

export default sleep;
